import { nanoid } from 'nanoid'

export const SEGMENTS_MAIN_STREET = {
  DEFAULT_BUILDING_HEIGHT_LEFT: 2,
  DEFAULT_BUILDING_HEIGHT_RIGHT: 2,
  DEFAULT_BUILDING_VARIANT_LEFT: 'wide',
  DEFAULT_BUILDING_VARIANT_RIGHT: 'wide',
  segments: [
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'dense' },
      width: 6,
      id: nanoid()
    },
    {
      type: 'sidewalk-tree',
      variant: { 'tree-type': 'big' },
      width: 2,
      id: nanoid()
    },
    {
      type: 'parking-lane',
      variant: {
        direction: 'inbound|left'
      },
      width: 8,
      id: nanoid()
    },
    {
      type: 'drive-lane',
      variant: {
        direction: 'inbound',
        'car-type': 'car'
      },
      width: 13,
      id: nanoid()
    },
    {
      type: 'turn-lane',
      variant: { direction: 'outbound|shared' },
      width: 12,
      id: nanoid()
    },
    {
      type: 'drive-lane',
      variant: {
        direction: 'outbound',
        'car-type': 'car'
      },
      width: 13,
      id: nanoid()
    },
    {
      type: 'parking-lane',
      variant: {
        direction: 'inbound|right'
      },
      width: 8,
      id: nanoid()
    },
    {
      type: 'sidewalk-tree',
      variant: { 'tree-type': 'big' },
      width: 2,
      id: nanoid()
    },
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'dense' },
      width: 6,
      id: nanoid()
    }
  ]
}
